module.exports = __webpack_public_path__ + "img/snb-dgjg.bc2d8274.svg";